import { loginOBO, loginPublisher, loginSSO } from 'core/crud/auth.crud';
import useAmplitude from 'core/hooks/useAmplitude';
import { useTranslate } from 'core/hooks/useTranslate';
import * as coreEntities from 'core/store/index';
import { AMPLITUDE_EVENT } from 'core/variables/constant';
import { useCallback, useReducer, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';

export function useAuthView() {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const { sendAmplitudeEvent } = useAmplitude();
  const { t } = useTranslate();

  const [state, setState] = useReducer((state, newState) => ({ ...state, ...newState }), {
    errorMsg: '',
    loading: false,
  });
  const [authData, setAuthData] = useState({});
  const [authError, setAuthError] = useState({});

  const enableLoading = () => {
    setState({ loading: true });
  };

  const disableLoading = () => {
    setState({ loading: false });
  };

  const submitLogin = useCallback(
    (email, pass) => {
      enableLoading();
      setTimeout(() => {
        loginPublisher(email, pass)
          .then((data) => {
            if (data.data && data.data.data && data.data.data.token) {
              disableLoading();
              dispatch(coreEntities.auth.actions.login(data.data.data));
            } else {
              showError(data);
            }
          })
          .catch((error) => {
            showError(error);
          });
      }, 1000);
    },
    [showError]
  );

  const onSSO = useCallback(
    (token, identity_provider) => {
      enableLoading();
      setTimeout(() => {
        loginSSO(token, identity_provider)
          .then((data) => {
            if (data.data.data.token) {
              disableLoading();
              dispatch(coreEntities.auth.actions.login(data.data.data));
            } else {
              showError(data);
            }
          })
          .catch((error) => {
            showError(error);
          });
      }, 1000);
    },
    [showError]
  );

  const onSSOForMSTeams = useCallback(
    (params) => {
      enableLoading();
      setTimeout(() => {
        loginOBO(params)
          .then((data) => {
            if (data.data && data.data.data && data.data.data.token) {
              setAuthData(data.data.data);
              disableLoading();
            } else {
              setAuthError(data);
            }
          })
          .catch((error) => {
            showError(error);
          });
      }, 1000);
    },
    [showError]
  );

  function showError(error) {
    sendAmplitudeEvent(AMPLITUDE_EVENT.LOGIN_FAILED);
    const errorKey = error?.error?.data?.error?.errorKey;
    const errorMsg = errorKey ? t('login:' + errorKey) : t('login:Invalid login');
    disableLoading();
    setState({ loading: false });
    addToast(errorMsg, {
      appearance: 'error',
      autoDismiss: true,
    });
  }

  return { form: 'login', loading: state.loading, submitLogin, onSSO, onSSOForMSTeams, authData, authError };
}
